/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.iaRobustesse.ts
 *
 * Messages de l'écran IA (/admin/ai-config) ajoutés pour l'activation de
 * l'IA en production (2026-10-04) : effort par fonction, requête réellement
 * envoyée (modèle, effort, nombre maximal de jetons), et essai RÉEL ou
 * simulé d'une fonction avec sa durée et son coût estimé. Fusionné dans
 * fr.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesIaRobustesseFr: Record<string, string> = {
  'iaRobustesse.effort.libelle': 'Effort',
  'iaRobustesse.effort.defaut': 'Par défaut ({effort})',
  'iaRobustesse.effort.low': 'Faible (low)',
  'iaRobustesse.effort.medium': 'Moyen (medium)',
  'iaRobustesse.effort.high': 'Élevé (high)',
  'iaRobustesse.effort.xhigh': 'Très élevé (xhigh)',
  'iaRobustesse.effort.max': 'Maximal (max)',
  'iaRobustesse.effort.aide':
    'Profondeur de réflexion de Claude Opus 5.5 et Sonnet 5.5, qui réfléchissent toujours : plus elle est haute, plus la réponse est lente et chère. Faible suffit pour les réponses courtes. Sans effet sur Haiku 4.5.',

  'iaRobustesse.requete.avecEffort':
    'Requête envoyée : {modele}, effort {effort}, {max} jetons au plus (réflexion comprise).',
  'iaRobustesse.requete.sansEffort': 'Requête envoyée : {modele}, sans réglage d’effort, {max} jetons au plus.',
  'iaRobustesse.requete.modeleFournisseur': 'modèle du fournisseur',

  'iaRobustesse.essai.titreReel': 'Essai réel de {libelle}',
  'iaRobustesse.essai.titreSimule': 'Essai simulé de {libelle}',
  'iaRobustesse.essai.introReel':
    'Appel RÉEL au fournisseur, sur un exemple fictif embarqué (aucune personne réelle). Il est compté dans la consommation de la fonction.',
  'iaRobustesse.essai.introSimule':
    'Pas de clé utilisable : c’est le simulateur qui répond. Rien ne part, rien n’est compté.',
  'iaRobustesse.essai.appel':
    'Modèle {modele}, effort {effort}, {max} jetons au plus. Durée {duree} s. Coût estimé {cout} € ({entree} jetons en entrée, {sortie} en sortie).',
  'iaRobustesse.essai.sansEffort': 'sans objet',
  'iaRobustesse.essai.echec':
    'Le fournisseur n’a pas répondu ({erreur}). En fonctionnement, la fonction aurait continué sans IA.',
  'iaRobustesse.essai.budget':
    'Budget atteint (fournisseur ou fonction) : l’essai réel n’a pas été lancé. En fonctionnement, la fonction continue sans IA.',
};
